import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ca1eaba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basePageWraper" }
const _hoisted_2 = { class: "is-hidden-mobile" }
const _hoisted_3 = { class: "desk" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-size-4 is-text-grey has-text-weight-semibold" }, " 회원가입이 완료 되었습니다. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 is-size-6 has-text-grey-light" }, " 가입한 이메일로 로그인 하세요. ", -1))
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = { class: "is-hidden-tablet" }
const _hoisted_8 = { class: "mobile" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-size-4 is-text-grey has-text-weight-semibold" }, " 회원가입이 완료 되었습니다. ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 is-size-6 has-text-grey-light" }, " 가입한 이메일로 로그인 하세요. ", -1))
const _hoisted_11 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goto_login && _ctx.goto_login(...args))),
            class: "button is-info"
          }, "로그인")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goto_login && _ctx.goto_login(...args))),
            class: "button is-info"
          }, "로그인")
        ])
      ])
    ])
  ]))
}